import { BrowserRouter } from 'react-router-dom';
import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/core/styles';
import { SnackbarProvider } from 'notistack';
import { InsightProvider, ToastProvider, AuthProvider, FetchProvider, UserProvider, NavProvider } from './components/contexts';
import { Layout, Routes } from './components/common';
import { IPublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { useEffect } from 'react';
import { _loginRequest } from './components/contexts/AuthContext';

const theme = createTheme({
    palette: {
        primary: {
            main: "#c2a07b"
        },
        secondary: {
            main: "#ff0000"
        },
        text: {
            secondary: "#c2a07b"
        }
    },
    overrides: {
        MuiStepIcon: {
            root: {
                '&$active': {
                    color: '#c2a07b',
                },
                '&$completed': {
                    color: '#d1d1d1',
                },
            },
        },
        MuiSwitch: {
        },
        MuiTabs: {
            indicator: {
                backgroundColor: "#c2a07b"
            }
        }
    }
});

type IApp = {
    baseUrl: string;
    msalInstance: IPublicClientApplication;
    isAccountLogged: boolean;
}

const App = ({ baseUrl, msalInstance, isAccountLogged }: IApp): JSX.Element => {
    const login = (): void => {
        msalInstance
        .initialize()
        .then(() => msalInstance.loginRedirect(_loginRequest))
        .catch(error => console.error(error));
    };

    useEffect((): void => {
        if (!isAccountLogged)
            login();
    }, []);

    return (
        <MsalProvider instance={msalInstance}>
            <BrowserRouter basename={baseUrl}>
                <InsightProvider>
                    <ThemeProvider theme={theme}>
                        <SnackbarProvider preventDuplicate maxSnack={5}>
                            <ToastProvider>
                                <AuthProvider>
                                    <FetchProvider>
                                        <UserProvider>
                                            <NavProvider>
                                                <Layout>
                                                    <Routes />
                                                </Layout>
                                            </NavProvider>
                                        </UserProvider>
                                    </FetchProvider>
                                </AuthProvider>
                            </ToastProvider>
                        </SnackbarProvider>
                    </ThemeProvider>
                </InsightProvider>
            </BrowserRouter>
        </MsalProvider>
    );
};

export default App;